export enum IVolumeDetailsPageTabs {
  Overview = 'overview',
}
